module.exports = __webpack_public_path__ + "img/chinesecompany213.15666e87.png";